export const CONVERSATIONS_BUYING_CONTEXT = "buying";
export const CONVERSATIONS_SELLING_CONTEXT = "selling";
export type CONVERSATIONS_CONTEXT_TYPE = "buying" | "selling";
export const CONVERSATIONS_CONTEXT_LOCAL_STORAGE_KEY = "conversations_context";
